export default "__VITE_ASSET__33104e8d__"